var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 829.7 425.2",
    style: {
      enableBackground: "new 0 0 829.7 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.st0{fill:#E30613;}\r\n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M778.7,173.6c-18.6-10.3-58.8-10.8-80.4-10.8c-21.6,0-61.8,0.5-80.4,10.8c-48.5,26.5-51,84.8-51,120.1 c0,35.8,2.5,94.2,51,120.6c18.6,10.3,58.8,10.8,80.4,10.8c21.6,0,61.8-0.5,80.4-10.8c48.5-26.5,51-84.8,51-120.6 C829.7,258.5,827.3,200.1,778.7,173.6 M723.8,347.2c-6.4,3.4-18.1,3.9-25.5,3.9c-7.4,0-19.1-0.5-25.5-3.9 c-11.8-6.9-12.3-30.9-12.3-53.9c0-22.6,0.5-45.6,12.3-52.5c6.4-3.4,18.1-3.9,25.5-3.9c7.4,0,19.1,0.5,25.5,3.9 c11.8,6.9,12.3,29.9,12.3,52.5C736.1,316.3,735.6,340.4,723.8,347.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.8,162.7V0h-51c-26.6,0-42.6,26.7-42.6,52.6v111.3c-12.7-0.9-28.7-1-37.8-1c-21.6,0-61.8,0.5-80.4,10.8 C2.5,200.1,0,258.5,0,293.8c0,35.8,2.5,94.2,51,120.6c18.6,10.3,58.8,10.8,80.4,10.8c21.6,0,61.8-0.5,80.4-10.8 c48.5-26.5,51-84.8,51-120.6c0-4.9-0.1-10.2-0.3-15.8L262.8,162.7 M156.9,347.2c-6.4,3.4-18.1,3.9-25.5,3.9s-19.1-0.5-25.5-3.9 c-11.8-6.9-12.3-30.9-12.3-53.9c0-22.6,0.5-45.6,12.3-52.5c6.4-3.4,18.1-3.9,25.5-3.9s19.1,0.5,25.5,3.9 c11.8,6.9,12.3,29.9,12.3,52.5C169.2,316.3,168.7,340.4,156.9,347.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M545.2,239.3c0-41.2-34.7-75.4-79.3-75.4c-21.8,0-30.6,0-52.2,0c-21.6,0-61.8-0.5-80.4,9.8 c-48.5,26.5-51,84.8-51,120.1c0,35.8,2.5,94.2,51,120.6c15.2,8.4,40.6,10.4,62.7,10.8c53.1,0.1,55.5-48.2,55.5-48.2 c0,18.5,15.7,48.2,45.1,48.2h48.5l0.1-158.7L545.2,239.3 M439.2,347.2c-6.4,3.4-18.1,3.9-25.5,3.9c-7.4,0-19.1-0.5-25.5-3.9 c-11.8-6.9-12.3-30.9-12.3-53.9c0-22.6,0.5-45.6,12.3-52.5c6.4-3.4,18.1-3.9,25.5-3.9c7.4,0,19.1,0.5,25.5,3.9 c11.8,6.9,12.3,29.9,12.3,52.5C451.5,316.3,451,340.4,439.2,347.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDao);
export default __webpack_public_path__ + "static/media/dao.16cc25dc3d1fad24f1f2a609ff110fec.svg";
export { ForwardRef as ReactComponent };